import { getCurrencyFormat, getDecimalFormat, getPercentFormat } from '@/i18n/numbers'
import { setColumnsVistas } from '@/services/grids/setColumnsVistas'
import { v4 as uuidv4 } from 'uuid'
import store from '@/store'
import { i18n } from '@/i18n'
import { passNumber, passMinus, passMayus, passSpecial } from '@/utils/regex'
import { preserve, discard } from '@/services/functions/preserve&discard'

const feedbackMixin = {
  methods: {
    // Generación de mensajes pop up en pantalla
    doFeedback: function (message = null, type = 'error', duration = 3000) {
      if (!message) {
        message = this.$t('feedback.error.general')
      }
      const options = {
        message,
        type,
        duration,
        showClose: true
      }

      this.$message(options)
    },
    resetControlFormChanges () {
      setTimeout(() => {
        store.commit('app/setFormChanges', false)
      }, 100)
    },
    /**
     * Mapea todos los datos de kendo a seleccionado o no seleccionado y establece los seleccionados
     * @param {Boolean|(item)=>Boolean} checked 
     */
    mapSelectionKendoGrouping (checked) {
      if (typeof checked !== 'function') {
        const checkedValue = !!checked
        checked = item => checkedValue
      }
      this.selected = []

      if (this.kendo.group && this.kendo.group.length > 0) {
        // Si detectamos agrupaciones:
        const countGroups = this.kendo.group.length
        const tempGridData = this.setKendoGroupingRecursive(this.kendo.dataResult.data, countGroups, checked)

        this.kendo.dataResult.data = tempGridData
      } else {
        // Si no hay agrupaciones
        const tempGridData = this.kendo.dataResult.data.map((item) => {
          return { ...item, selected: checked(item) }
        })
        this.kendo.dataResult.data = tempGridData
      }
      var dataItems = this.kendo.dataResult.data
      this.kendo.group.forEach(_ => { dataItems = dataItems.flatMap(x => x.items) })
      // this.selected = this.data.filter(x => checked(x))
      this.selected = dataItems.filter(x => checked(x))
    },
    /**
     * Cambia de forma recursiva a un valor los campos seleccionados en base a profundidad de recursividad indicada como longitud
     * @param {Array} data 
     * @param {Number} longitud 
     * @param {(item)=>Boolean} checked 
     * @returns 
     */
    setKendoGroupingRecursive (data, longitud, checked) {
      if (longitud === 0) {
        return data.map((item) => {
          return { ...item, selected: checked(item) }
        })
      }

      return data.map((group) => {
        const items = this.setKendoGroupingRecursive(group.items, longitud - 1, checked)
        return { ...group, items }
      })
    },
    // Generación de objeto con columnas y agrupaciones para la exportación a Excel
    getColumnsGroupExcelMixin: function (kendoColumns = null, kendoGroups = null) {
      let res = []
      if (kendoColumns === null || kendoGroups === null) return res
      res = kendoColumns.filter(x => {
        if ((x.hidden === false || x.hidden === undefined) && x.field !== 'selected' && x.field !== ' ' && x.field !== undefined) return x
      }).sort((a, b) => {
        return a.orderIndex - b.orderIndex
      }).map(x => {
        return { columna: x.field, group: false, ordenGroup: -1 }
      })
      let ordenBase = 0
      kendoGroups.forEach(group => {
        res.map(x => {
          if (x.columna === group.field) {
            x.group = true
            x.ordenGroup = ordenBase
          }
          return x
        })
        ordenBase = ordenBase + 1
      })
      res.forEach(x => {
        if (x.columna.includes('.')) {
          x.columna = x.columna.substring(x.columna.indexOf('.') + 1, x.columna.length)
        }
      })
      return res
    },
    // Generación de objeto de ordenación y ordenación de agrupación para petición en back
    getObjOrderMixin: function (kendoGroup = null, kendoSort = null, keepKeys = false) {
      let obj = {}
      if (kendoGroup === null || kendoSort === null) return obj
      if (kendoGroup.length > 0) {
        kendoGroup.forEach(element => {
          let name = element.field
          if (!keepKeys) {
            name = name.toLowerCase()
            if (name.includes('.')) {
              name = name.split('.')[1]
            }
          }
          obj[name] = (element.dir === undefined || element.dir === 'asc')
        })
        obj = { order: obj }
      }
      const obj2 = {}
      if (kendoSort.length > 0) {
        kendoSort.forEach(element => {
          let name = element.field
          if (!keepKeys) {
            name = name.toLowerCase()
            if (name.includes('.')) {
              name = name.split('.')[1]
            }
          }
          obj2[name] = (element.dir === 'asc')
        })
        if (obj.order) {
          obj.order = { ...obj.order, ...obj2 }
        } else {
          obj = { order: obj2 }
        }
      }
      return obj
    },
    // Enviar datos de columnas por vista
    sendUpdatedColumns: async function (columns) {
      try {
        const sendDataColumns = columns.filter(column => column.hidden !== true && column.className !== 'added-column').sort(function (a, b) {
          return a.orderIndex - b.orderIndex
        }).map(column => column.field).filter(field => {
          if (field !== undefined && field !== null && field !== '' && field !== 'selected') {
            return field
          }
        }).join(';')
        
        const payload = {
          IdVista: this.idVista,
          Columnas: sendDataColumns,
          Version: this.$store.getters['app/version']
        }
        const response = await setColumnsVistas(payload)
        if (response.blnError === true) {
          console.err('Error: sendUpdatedColumns')
        } 
      } catch (error) {
        console.err(error)
        // this.doFeedback(error)
      } 
    },
    // Truncar textos
    truncate: function (str, n, useWordBoundary) {
      if (str.length <= n) { return str }
      const subString = str.substring(0, n) // the original check
      return (useWordBoundary
        ? subString.substring(0, subString.lastIndexOf(' '))
        : subString) + '...'
    },
    // Obtiene la extensión de un nombre de archivo con un regex
    getExtensionFromFile (text) {
      const regex = /(?:\.([^.]+))?$/
      const res = regex.exec(text)[1]
      return res
    },
    // Devuelve una promesa para obtener el base64 de un archivo
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        let res = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          res = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(res)
        }
      })
    },
    // Genera notificaciones de windows
    notifyWindows: function (title = 'Title', body = 'body', tag = null) {
      if (!window.Notification) {
        console.log('Browser does not support notifications.')
      } else {
        const idNotify = tag === null ? uuidv4() : tag
        const routeIcon = window.location.origin + '/ms-icon-310x310.png'
        // check if permission is already granted
        if (Notification.permission === 'granted') {
          // show notification here
          var notify = new Notification(title, {
            body,
            icon: routeIcon,
            tag: idNotify,
          })
          console.log('Send notify', notify)
        } else {
          // request permission from user
          Notification.requestPermission().then(function (p) {
            if (p === 'granted') {
              // show notification here
              var notify = new Notification(title, {
                body,
                icon: routeIcon,
                tag: idNotify,
              })
              console.log('Send notify', notify)
            } else {
              console.log('User blocked notifications.')
            }
          }).catch(function (err) {
            console.error(err)
          })
        }
      }
    },
    // Devuelve el valor de un tag (Tags de Filtros y Búsquedas)
    getValueTagFormated (tagObj) {
      const extraparams = tagObj.extraparams || {}
      const tagName = this.multipleFilters.find(x => new RegExp('^' + x.NombreTag + '\\d*$').test(tagObj[0]))?.NombreTag
      if (tagName) {
        if (Array.isArray(tagObj[2])) {
          let once = i18n.tc('app.plural_filter_tag', 1)
          let data = tagObj[2]

          if (tagName === 'metadatos') {
            const valor = [4, 5].includes(tagObj[2].operador) ? '' : `"${tagObj[2].valor}"`
            once = `"${tagObj[2].campo}" ${this.operators.find(x => x.value === tagObj[2].operador)?.nombreTag || ':'} ${valor}`
            data = tagObj[2]
          }

          switch (data.length) {
            case 0: return null
            case 1: return once
            default: return i18n.tc('app.plural_filter_tag', data.length)
          }
        }
        if (tagName === 'metadatos') {
          const valor = [4, 5].includes(tagObj[2].operador) ? '' : `"${tagObj[2].valor}"`
          return `"${tagObj[2].campo}" ${this.operators.find(x => x.value === tagObj[2].operador)?.nombreTag || ':'} ${valor}`
        }
        return tagObj[2]
      } else if (Array.isArray(tagObj[2])) {
        if (tagObj[0] === 'estadoExtra') {
          const tmp = tagObj[2].map(y => this.tiposEstados.filter(x => x.id === y)[0].Nombre)
          return tmp.join(', ')
        } else if (tagObj[0] === 'estadoExtraRecibidas') {
          const tmp = tagObj[2].map(y => this.tiposEstadosRecibidas.filter(x => x.id === y)[0].Nombre)
          return tmp.join(', ')
        } else if (tagObj[0] === 'PGE') {
          const tipos = this.pgeTypesRecepcion.filter(x =>
            tagObj[2].includes(x.id)
          )
          switch (tipos.length) {
            case 0: return null
              
            case 1: return tipos[0].name
          
            default: return i18n.tc('app.plural_filter_tag', tipos.length)
          }
        } else if (tagObj[0] === 'metadatos') {
          const metadatos = tagObj[2]
          switch (metadatos.length) {
            case 0: return null
              
            case 1: return `"${metadatos[0].campo}" ${this.operators.find(x => x.value === metadatos[0].operador)?.nombreTag || ':'} "${metadatos[0].valor}"`
          
            default: return i18n.tc('app.plural_filter_tag', metadatos.length)
          }
        }
        return tagObj[2].join(', ')
      } else if (tagObj[0] === 'metadatos') {
        return `"${tagObj[2].campo}" ${this.operators.find(x => x.value === tagObj[2].operador)?.nombreTag || ':'} "${tagObj[2].valor}"`
      } else if (tagObj[0] === 'estadoExtra') {
        const EstadoNombre = this.tiposEstados.filter(x =>
          x.id === tagObj[2]
        )[0].Nombre
        return EstadoNombre
      } else if (tagObj[0] === 'estadoExtraRecibidas') {
        const EstadoNombre = this.tiposEstadosRecibidas.filter(x =>
          x.id === tagObj[2]
        )[0].Nombre
        return EstadoNombre
      } else if (tagObj[0] === 'OrigenFactura') {
        const OrigenFactura = this.tiposOrigenFactura.filter(x =>
          x.id === tagObj[2]
        )[0].Nombre
        return OrigenFactura
      } else if (tagObj[0] === 'tipoInvoiceClass') {
        const tipoName = this.tiposInvoiceClass.filter(x =>
          x.id === tagObj[2]
        )[0].Nombre
        return tipoName
      } else if (tagObj[0] === 'IdEstadoVerifactu') {
        const tipoName = this.tiposEstadoVerifactu.filter(x =>
          x.id === tagObj[2]
        )[0].Nombre
        return tipoName
      } else if (tagObj[0] === 'IdTipoFactura') {
        const tipoName = this.tiposFacturas.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tipoName
      } else if (tagObj[0] === 'IdAccionVerifactu') {
        const tipoName = this.tiposOperacion.filter(x =>
          x.id === tagObj[2]
        )[0].Nombre
        return tipoName
      } else if (tagObj[0] === 'tipoImportacion') {
        const tipoName = this.tiposImportacion.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tipoName
      } else if (tagObj[0] === 'tipoImportacionEstado') {
        const tipoName = this.tiposImportacionEstado.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tipoName
      } else if (tagObj[0] === 'PaqueteContratacion') {
        const tipoName = this.tiposPaquetesContratacion.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tipoName
      } else if (tagObj[0] === 'FaseConfiguracion') {
        const tipoName = this.tiposFasesConfiguracion.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tipoName
      } else if (tagObj[0] === 'pge' || tagObj[0] === 'FormaEnvio') {
        const tipoName = this.pgeTypes.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tipoName
      } else if (tagObj[0] === 'PGE') {
        const tipoName = this.pgeTypesRecepcion.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tipoName
      } else if (tagObj[0] === 'role') {
        const rolName = this.roles.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return rolName
      } else if (tagObj[0] === 'tipoAuth') {
        const tipoAuthName = this.tiposAuth.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tipoAuthName
      } else if (tagObj[0] === 'idioma') {
        const tipoIdioma = this.tiposIdioma.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tipoIdioma
      } else if (tagObj[0] === 'tipoGrupo') {
        const tiposGrupo = this.tiposGrupo.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tiposGrupo
      } else if (tagObj[0] === 'PersonTypeCode' || tagObj[0] === 'PersonType') { 
        const tiposPersona = this.tiposPersona.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tiposPersona
      } else if (tagObj[0] === 'ResidenceTypeCode' || tagObj[0] === 'ResidenceType') { 
        const tiposResidencia = this.tiposResidencia.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tiposResidencia
      } else if (tagObj[0] === 'CountryCode') { 
        const tiposPais = this.tiposPais.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tiposPais
      } else if (tagObj[0] === 'UnitOfMeasure') { 
        const tiposUnidadesMedida = this.tiposUnidadesMedida.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tiposUnidadesMedida
      } else if (tagObj[0] === 'AccountType') { 
        const tiposCuenta = this.tiposCuenta.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tiposCuenta
      } else if (tagObj[0] === 'PaymentType') { 
        const formasDePago = this.formasDePago.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return formasDePago
      } else if (tagObj[0] === 'TaxType') { 
        const tiposCodigoImpuesto = this.tiposCodigoImpuesto.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tiposCodigoImpuesto
      } else if (tagObj[0] === 'TaxCategory') { 
        const tiposCategoriaImpuesto = this.tiposCategoriaImpuesto.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tiposCategoriaImpuesto
      } else if (tagObj[0] === 'RolAgenda') { 
        const tiposRolAgenda = this.tiposRolAgenda.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tiposRolAgenda
      } else if (tagObj[0] === 'RoleTypeCode' || tagObj[0] === 'RoleCode') { 
        const tiposRolAdministrativeCenter = this.tiposRolAdministrativeCenter.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tiposRolAdministrativeCenter
      } else if (tagObj[0] === 'rolefb2b' || tagObj[0] === 'Role') { 
        const tiposRolAdministrativeCenterfb2b = this.tiposRolAdministrativeCenterfb2b.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tiposRolAdministrativeCenterfb2b
      } else if (tagObj[0] === 'tipoDistribuidor') {
        const tipoDistribuidor = this.tiposDistribuidor.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tipoDistribuidor
      } else if (tagObj[0] === 'tipoProvisionamiento') {
        const tipoProvisionamiento = this.tiposProvisionamiento.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tipoProvisionamiento
      } else if (tagObj[0] === 'tipoCert') {
        const tipoCert = this.tiposCert.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tipoCert
      } else if (tagObj[0] === 'tipoServicio') {
        const tipoServicio = this.tiposServicio.filter(x =>
          x.id === tagObj[2]
        )[0].name
        return tipoServicio
      } else if (tagObj[0] === 'empresa' || tagObj[0] === 'distribuidor' || tagObj[0] === 'Cliente' || 
                 tagObj[0] === 'Empresa' || tagObj[0] === 'idDistribuidor' || tagObj[0] === 'idCliente' ||
                 tagObj[0] === 'distribuidor.idDistribuidor') {
        return tagObj[2]?.Nombre ?? tagObj[2]
      } else if (tagObj[0] === 'evento') {
        return tagObj[2].replaceAll('_', ' ')
      } else if (tagObj[2] === true) {
        return i18n.t('app.yes')
      } else if (tagObj[2] === false) {
        return i18n.t('app.no')
      } else if (tagObj[0] === 'partner' || tagObj[0] === 'grupoCliente') {
        return tagObj[3]
      } else if (tagObj[0] === 'tipoNotif') {
        return this.$store.getters['app/tiposNotificacion'].filter(x => x.id === tagObj[2])[0].Nombre
      } else if (tagObj[0] === 'notificationType') {
        return this.tiposWebhookNotification.find(x => x.value === tagObj[2])?.label ?? tagObj[2]
      } else if (extraparams.type === 'number' && tagObj[2] !== null && isFinite(tagObj[2])) {
        return i18n.n(tagObj[2], extraparams.format || 'decimal')
      } else if (extraparams.type === 'date' && !isNaN(Date.parse(tagObj[2]))) {
        const dateValue = Date.parse(tagObj[2])
        const separators = { date: extraparams.separators?.date ?? '-', datetime: extraparams.separators?.datetime ?? ' ' }
        if (extraparams.format) {
          return i18n.d(dateValue, extraparams.format, separators)          
        }
        let format = 'numeric_date'
        if (tagObj[2].includes('T') && tagObj[2].split('T')[1] !== '00:00:00') {
          format = 'numeric_datetime'
        }
        return i18n.d(dateValue, format, separators)
      }
      return tagObj[2]
    },
    // Validación contraseñas element ui
    isPasswordValid: function (rule, value, callback, { validation = this.validation }) {
      if (!value) {
        validation.numChar = false
        validation.numMin = false
        validation.charMinus = false
        validation.charMayus = false
        validation.especial = false
        return callback(new Error(i18n.t('validation.complete')))
      } else {
        validation.numChar = !(value.length < 12)
        validation.numMin = passNumber.test(value)
        validation.charMinus = passMinus.test(value)
        validation.charMayus = passMayus.test(value)
        validation.especial = passSpecial.test(value)

        if (Object.values(validation).some(x => x !== true)) {
          return callback(new Error(i18n.t('validation.pass.main')))
        }
      }
      callback()
    },
    // Validación repetición de contraseña element ui
    isRepeatPasswordValid: function (rule, value, callback, { validationRepeat = this.validationRepeat, checkPassword = this.form.password }) {
      if (!value) {
        validationRepeat.numChar = false
        validationRepeat.numMin = false
        validationRepeat.charMinus = false
        validationRepeat.charMayus = false
        validationRepeat.especial = false
        validationRepeat.passRepeat = false
        return callback(new Error(i18n.t('validation.complete')))
      } else {
        validationRepeat.numChar = !(value.length < 12)
        validationRepeat.numMin = passNumber.test(value)
        validationRepeat.charMinus = passMinus.test(value)
        validationRepeat.charMayus = passMayus.test(value)
        validationRepeat.especial = passSpecial.test(value)
        validationRepeat.passRepeat = value === checkPassword

        if (Object.keys(validationRepeat).filter(x => x !== 'passRepeat').some(x => validationRepeat[x] !== true)) {
          return callback(new Error(i18n.t('validation.pass.main')))
        }
        if (!validationRepeat.passRepeat) {
          return callback(new Error(i18n.t('validation.pass.pass_repeat')))
        }
      }
      callback()
    },
    // Descarga en el navegador un fichero
    downloadBlob (response, filename) {
      const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      filename = decodeURI(filename)
      link.download = filename
      link.click()
    },
    
    preserve,
    discard,

    /**
     * @param {Array} arr 
     * @param {Boolean?} finalOr 
     * @returns {String}
     */
    listToCommaString: function (arr, finalOr = null) {
      if (finalOr === null) {
        return arr.join(', ')
      }
      const finalSeparator = finalOr ? i18n.t('app.or') : i18n.t('app.and')
      if (arr.length === 0) {
        return ''
      }
      if (arr.length === 1) {
        return `${arr[0]}`
      }
      const lastItem = arr.pop()
      return `${arr.join(', ')} ${finalSeparator} ${lastItem}`
    }, 
  }
}

const numberFilter = {
  filters: {
    money: function (value, code = 'EUR', locale = null, format = null) {
      return getCurrencyFormat(value, code, locale, format)
    },
    number: function (value, minDecimal = 0, maxDecimal = 2, locale = null, format = null) {
      return getDecimalFormat(value, minDecimal, maxDecimal, locale, format)
    },
    percent: function (value, minDecimal = 0, maxDecimal = 2, locale = null, format = null) {
      return getPercentFormat(value, minDecimal, maxDecimal, locale, format)
    }
  }
}

export { feedbackMixin, numberFilter }
